import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {  useDispatch, useSelector  } from 'react-redux';
import { setRedirectURL } from '../reducers/redirectURLSlice';
import { objectiveLicences } from '../reducers/licencesSlice';
import { LOCATIONS } from '../utils/const';

const AuthRoute = ({ component: Component,licenced, ...rest }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken');
  const hasValidLicence =  useSelector(objectiveLicences);

  return (
    <Route
      { ...rest }
      render={ props => {
        if (!token) {
          dispatch(setRedirectURL({ url: props.location.pathname }));
        }
        if (token && !licenced ) return (<Component { ...props } />);
        if (token && licenced && hasValidLicence) return (<Component { ...props } />);
        if (token && licenced && !hasValidLicence) {
          dispatch(setRedirectURL({ url: props.location.pathname }));
          return (<Redirect
            to={ {
              pathname: LOCATIONS.MISSING_LICENCE,
              state: { from: props.location }
            } }
          />);
        }

        if (!token ) return ( <Redirect
          to={ {
            pathname: LOCATIONS.HOME,
            state: { from: props.location }
          } }
        />);
      }
      }
    />
  );
};

const NonAuthRoute = ({ component: Component, ...rest }) => {
  const token = rest.path === LOCATIONS.REGISTRATION ? '' : localStorage.getItem('jwtToken');

  return (
    <Route
      { ...rest }
      render={ props =>
        (!token) ? (
          <Component { ...props } />
        ) : (
          <Redirect
            to={ {
              pathname: LOCATIONS.OBJECTIVES,
              location: { from: props.location }
            } }
          />
        )
      }
    />
  );
};

const NormalRoute =  ({ component: Component, ...rest }) => {
  return (
    <Route
      { ...rest }
      render={ props =>
        <Component { ...props }/>
      }
    />
  );
};

export const ManageAuthRoutes = route => {
  if (route.auth) {
    return (
      <AuthRoute
        path={ route.path }
        exact={ route.exact }
        component={ route.component }
        licenced={ route.licenced }
      />
    );
  } else if (route.noneauth) {
    return (
      <NonAuthRoute
        path={ route.path }
        exact={ route.exact }
        component={ route.component }
      />
    );
  } else {
    return (
      <NormalRoute
        path={ route.path }
        exact={ route.exact }
        component={ route.component }
      />
    );
  }
};

export default ManageAuthRoutes;
